import {formMessages} from './messages'
export default {
  name: 'es',
  messages: formMessages.es
}



// WEBPACK FOOTER //
// ./src/core/locale/translation/validation/es_MX.js